import {Component, OnInit, Input} from '@angular/core';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {Permiso} from '../model/permiso';
import {Router} from '@angular/router';
import {LoginService} from '../login/login.service';

@Component({
  selector: 'sura-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent {

  links: Permiso[] = [];
  background = '';
  @Input() public linkActive: string;

  constructor(private router: Router, private _loginService: LoginService) {
    this.linkActive = this.router.url;
    this.obtenerLinks();
  }

  obtenerLinks() {
    const menus = JSON.parse(localStorage.getItem(ParametrosConst.USUARIO_MENU));

    if (menus != null && menus instanceof Array) {
      for (let index = 0; index < menus.length; index++) {
        const object = new Permiso();
        object.link = menus[index].descripcion;
        object.path = menus[index].url;
        this.links.push(object);
      }
    } else {
      this._loginService.logout();
      this.router.navigate(['/ingreso'], {queryParams: {returnUrl: this.linkActive}});
    }
  }

  obtenerNombre() {
    try {
      const object = JSON.parse(localStorage.getItem(ParametrosConst.USUARIO_LOGIN));
      return object['nombres'] + ' ' + object['apellidos'];
    } catch (error) {
      return '';
    }
  }

  toggleBackground() {
    this.background = this.background ? '' : 'primary';
  }
}
